/**
 * Highlight item data structure.
 */
export interface IHighlight
{
	/** Optional title (e.g., number) */
	title?: string
	/** Description text */
	description: string
	/** Optional image configuration */
	image?: {
		/** Image source URL */
		src: string
		/** Image alt text */
		alt: string
		/** Image height in pixels */
		height: number
		/** Image width in pixels */
		width: number
	}
}

/**
 * Highlight: 35 ambulances available
 */
export const HIGHLIGHT_35_AMBULANCES: IHighlight = {
	description: '35 ambulancií',
	image: {
		src: `/assets/images/illustrations/medante-icons/number-35.svg`,
		alt: '35 ambulancií',
		height: 36,
		width: 57
	}
}

/**
 * Highlight: Holistic approach to healthcare
 */
export const HIGHLIGHT_HOLISTIC_APPROACH: IHighlight = {
	description: 'Ľudský prístup',
	image: {
		src: `/assets/images/illustrations/medante-icons/human.svg`,
		alt: 'Ľudský prístup',
		height: 49,
		width: 41
	}
}

/**
 * Highlight: Available appointments
 */
export const HIGHLIGHT_AVAILABLE_APPOINTMENTS: IHighlight = {
	description: 'Dostupné termíny',
	image: {
		src: `/assets/images/illustrations/medante-icons/clock.svg`,
		alt: 'Dostupné termíny',
		height: 53,
		width: 53
	}
}

/**
 * Highlight: Free parking
 */
export const HIGHLIGHT_FREE_PARKING: IHighlight = {
	description: 'Parkovanie zdarma',
	image: {
		src: `/assets/images/illustrations/medante-icons/parking.svg`,
		alt: 'Parkovanie zdarma',
		height: 53,
		width: 53
	}
}

/**
 * Highlight: Year-round care
 */
export const HIGHLIGHT_YEAR_ROUND_CARE: IHighlight = {
	description: 'Starostlivosť po celý rok',
	image: {
		src: `/assets/images/illustrations/medante-icons/heart.svg`,
		alt: 'Starostlivosť po celý rok',
		height: 49,
		width: 51
	}
}

/**
 * Highlight: Client center support
 */
export const HIGHLIGHT_CLIENT_CENTER: IHighlight = {
	description: 'Klientske centrum',
	image: {
		src: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/illustrations/medante-icons/client-center.svg`,
		alt: 'Klientske centrum',
		height: 51,
		width: 49
	}
}
